<template lang="pug">
div(v-if="group")
  .icon-img-block(@click.stop="edit()")
    v-img(:src="mediaHost + group.icon", v-if="group.icon")
    v-icon(v-else) mdi-image
  v-dialog(v-model="dialog", max-width="250")
    v-card
      v-toolbar(flat, dense)
        .overline Group Icon
      v-divider
      v-card-text.text-center
        croppa.my-5(
          v-model="myCroppa",
          :width="180",
          :height="180",
          :quality="2",
          :canvas-color="canvas_color",
          initial-size="contain"
        )
        v-text-field(
          v-model="canvas_color",
          label="Background Color",
          hint="Name, hex code, or valid color format"
        )
        v-btn(
          @click="generateBlob()",
          :loading="loading",
          block,
          color="secondary"
        ) save
</template>

<script>
export default {
  name: "CatalogGroupIcon",
  props: ["group"],
  data() {
    return {
      dialog: false,
      myCroppa: {},
      loading: false,
      mediaHost: process.env.VUE_APP_MEDIAHOST,
      canvas_color: "#FFFFFF",
    };
  },
  methods: {
    edit() {
      this.dialog = true;
    },
    generateBlob() {
      this.myCroppa.generateBlob(
        (blob) => {
          if (!blob) {
            this.myCroppa.chooseFile();
            return;
          }
          this.uploadLogo(blob);
        },
        "image/jpeg",
        0.8
      );
    },
    async uploadLogo(blob) {
      if (!this.group || !this.group._id) return;
      this.loading = true;
      const groupId = this.group._id;
      const formData = new FormData();
      formData.append("file", blob);
      formData.append("groupId", groupId);
      try {
        const result = await this.$api.catalog.group.custom(
          "updateIcon",
          formData
        );
        this.$store.dispatch("catalog/updateGroup", result);
        this.dialog = false;
      } catch (e) {
        this.$toast.error(e.response?.data || e.message);
      }
      this.loading = false;
    },
  },
};
</script>

<style lang="sass" scoped>
.icon-img-block
  width: 180px
  height: 180px
  margin-left: auto
  margin-right: auto
  border-radius: 6px
  overflow: hidden
  cursor: pointer
</style>